import { BaseDto } from './base.dto';
import { StockLocationDto } from './stockLocation.dto';

export class RecipeStockLocationDto extends BaseDto {
  recipeId: number;
  stockLocationId: number;
  stockLocation?: StockLocationDto;
  sequence: number;
}